<script setup lang="ts">
  import { useClipboard } from '@vueuse/core';
  import { watch } from 'vue';

  import { toast } from '@ui/components/sonner';

  import Button from './Button.vue';
  import type { Props as ButtonProps } from './Button.vue';

  const props = defineProps<ButtonProps & { copyValue: string }>();

  const { copied, copy } = useClipboard({ source: props.copyValue });

  watch(copied, () => {
    if (copied.value) {
      toast.info('Copied to clipboard');
    }
  });
</script>

<template>
  <Button v-bind="props" @click.stop="copy(copyValue)">
    <slot />
  </Button>
</template>

<style scoped></style>
